<template>
    <div class="d-flex align-items-center">
        <div v-if="showPreviewBtn">
            <pc-loader
                v-bind:loading="loading"
                small>
                <pc-button
                    small
                    v-on:click="previewItem">
                    {{ previewButton }}
                </pc-button>
            </pc-loader>
        </div>
        <div v-if="showViewBtn">
            <pc-loader
                v-bind:loading="loading"
                small>
                <pc-button
                    small
                    v-on:click="viewItem">
                    {{ viewButton }}
                </pc-button>
            </pc-loader>
        </div>
    </div>
</template>
<script>
    import Vuex from "vuex";

    import { ENVELOPE_ITEM_TYPE } from "ESignatures/EditEnvelope/editEnvelopeStore";
    import { PROGRAM_TYPES } from "SharedStores/Program/programStore";
    import { PROJECT_FORM_NAMESPACE, PROJECT_FORM_TYPES } from "Forms/Components/ProjectForm/projectFormStore";
    import { PROJECT_FORM_CONTROLLER_TYPES } from "Forms/Components/ProjectForm/projectFormControllerStore";
    import { isModuleRegistered } from "SharedStores/util";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "../i18n/eSignature.i18n";

    export default {
        props: {
            itemDefinition: { type: Object, required: true }
        },
        data() {
            return {
                loading: false
            };
        },
        computed: {
            ...mapI18n(KEYS, NAMESPACE),
            type() {
                return this.itemDefinition.Type;
            },
            sourceDefinition() {
                switch (this.type) {
                    case ENVELOPE_ITEM_TYPE.Attachment:
                        return this.attachmentDefinitionFromId(this.itemDefinition.AttachmentDefinitionId);
                    case ENVELOPE_ITEM_TYPE.ContentItem:
                        return this.getContentLibraryItemById(this.itemDefinition.ContentItemId);
                    case ENVELOPE_ITEM_TYPE.DocumentTemplate:
                        return this.getGeneratedDocumentTemplateById(this.itemDefinition.DocumentTemplateDefinitionId);
                    default:
                        throw `Unrecognized item type ${this.type}`;
                }
            },
            showPreviewBtn() {
                return this.type === ENVELOPE_ITEM_TYPE.DocumentTemplate;
            },
            showViewBtn() {
                return this.type === ENVELOPE_ITEM_TYPE.Attachment || this.type === ENVELOPE_ITEM_TYPE.ContentItem;
            },
            ...Vuex.mapGetters({
                getGeneratedDocumentTemplateById: PROGRAM_TYPES.getters.getGeneratedDocumentTemplateById,
                attachmentDefinitionFromId: PROGRAM_TYPES.getters.attachmentDefinitionFromId,
                getContentLibraryItemById: PROGRAM_TYPES.getters.getContentLibraryItemById
            })
        },
        methods: {
            previewItem() {
                if (this.type !== ENVELOPE_ITEM_TYPE.DocumentTemplate) {
                    throw `Cannot preview non-document-template item of type ${this.type}`;
                }

                if (!isModuleRegistered(PROJECT_FORM_NAMESPACE, this.$store.state)) {
                    return;
                }

                this.doAsyncActionWithLoader(async () => {
                    await this.generateEnvelopeItemDocument({
                        envelopeItemDefinitionId: this.itemDefinition.PublicId
                    });
                });
            },
            viewItem() {
                if (!isModuleRegistered(PROJECT_FORM_NAMESPACE, this.$store.state)) {
                    return;
                }

                this.doAsyncActionWithLoader(async () => {
                    await this.viewEnvelopeItem({
                        envelopeItemDefinitionId: this.itemDefinition.PublicId
                    });
                });
            },
            async doAsyncActionWithLoader(asyncAction) {
                if (this.loading) {
                    return;
                }

                try {
                    this.loading = true;
                    await asyncAction();
                } finally {
                    this.loading = false;
                }
            },
            ...Vuex.mapActions({
                generateEnvelopeItemDocument: PROJECT_FORM_TYPES.actions.generateEnvelopeItemDocument,
                viewEnvelopeItem: PROJECT_FORM_CONTROLLER_TYPES.actions.viewEnvelopeItem
            })
        }
    };
</script>
